import type { V10ControlRoomSection } from "../adapters/v10-phase-model.js";
import type { V10SectionProgressStatus } from "../adapters/v10-project-adapters.js";
import { V10_SECTION_LABELS } from "../adapters/v10-phase-model.js";

export function V10PhaseStrip({
  activeSection,
  sectionProgress,
  onSectionChange,
  showLiveCare: _showLiveCare = true,
}: {
  readonly activeSection: V10ControlRoomSection;
  readonly sectionProgress: Record<V10ControlRoomSection, V10SectionProgressStatus> | null;
  readonly onSectionChange: (section: V10ControlRoomSection) => void;
  /** @deprecated Canonical tabs always include overview (live-care alias); kept for call-site compat. */
  readonly showLiveCare?: boolean;
}) {
  const sections = Object.entries(V10_SECTION_LABELS) as [V10ControlRoomSection, string][];

  return (
    <ol className="v10-phase-strip" aria-label="Project lifecycle">
      {sections.map(([id, label]) => {
        const progress = sectionProgress?.[id] ?? "upcoming";
        const openTab = activeSection === id;
        return (
          <li key={id}>
            <button
              type="button"
              className={`v10-phase-step v10-phase-step--${progress}${openTab ? " v10-phase-step--open" : ""}`}
              aria-current={progress === "current" ? "step" : undefined}
              onClick={() => onSectionChange(id)}
            >
              {label}
            </button>
          </li>
        );
      })}
    </ol>
  );
}
